import type { Account } from '@api/hooks/useAccounts';
import { Typography } from '@gurupay/gp-ui-library';
import { AccountInfo } from '@pages/accounts/components';
import { formatNumberAmount } from '@utils/utils';

interface AccountInfoCardProps {
	accountTitle: string;
	currencyTitle: string;
	balanceTitle: string;
	account: Account;
}

const AccountInfoCard = ({
	accountTitle,
	currencyTitle,
	balanceTitle,
	account,
}: AccountInfoCardProps) => (
	<div className="flex flex-col sm:flex-row gap-space-16 border border-neutral-100 rounded-lg p-space-16">
		<div className="flex-1">
			<Typography className="font-medium text-neutral-600 pb-space-8" level="small-text">
				{accountTitle}
			</Typography>
			<AccountInfo {...account} />
		</div>
		<div className="grow-0">
			<Typography className="font-medium text-neutral-600 pb-space-8" level="small-text">
				{currencyTitle}
			</Typography>
			<Typography className="font-bold block sm:text-right" level="small-text">
				{account?.currency}
			</Typography>
		</div>
		<div className="sm:text-right grow-0">
			<Typography className="font-medium text-neutral-600 pb-space-8" level="small-text">
				{balanceTitle}
			</Typography>
			<Typography className="font-bold block" level="small-text">
				{formatNumberAmount(account?.availableBalance)}
			</Typography>
		</div>
	</div>
);

export default AccountInfoCard;
